import AddPrimaryBeneficiary from './AddprimaryBeneficiaryContainer';

export default AddPrimaryBeneficiary;
